import classNames from "classnames";
import { DComponent } from "../DComponent";
import { isCountryVN, isMobileByWidth } from "../../utils/utils";
import { apiGetLocationOffice } from "../../utils/api";
import LocationItem from "../../pages/contact/components/LocationItem";
import { LocalStorage } from "../../models/LocalStorage";
import Env from "../../environments";
import { listenEvent, EVENTS } from "../../utils/event";
import { SUBMENU_TERM_OF_USE } from "../../utils/menu";

export default class Footer extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    isCompact = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("Footer", isCompact ? "is-compact" : "is-normal"),
    }, true, defaultLoading);
    this.isCompact = isCompact;
    this.listOffices = [];
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "Footer");
  }

  loadHtml() {
    return this.isCompact ? require("html-loader!./compact.html") : isMobileByWidth() ? require("html-loader!./indexMobile.html") : require("html-loader!./index.html");
  }

  after() {
    this.genHtmlTermOfUse();
    this.getLocation(LocalStorage.getLanguage());
    this.onLanguage(LocalStorage.getLanguage());
    this.onChangeCountry(LocalStorage.getShipping());
    $(".apps .chplay a, .apps .appstore a").attr("href", Env.DUTY_CAST_EXTENSION_INSTALL_CHPLAY);

    listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
      this.onLanguage(data);
      this.genHtmlTermOfUse();
    })
    listenEvent(EVENTS.CHANGE_COUNTRY, (data) => {
      this.onChangeCountry(data);
      this.genHtmlTermOfUse();
    })
  }

  genHtmlTermOfUse() {
    let htmlTerm = `<div data-i18n="footer_termPrivacy" class="menu-category"></div>`;
    SUBMENU_TERM_OF_USE.forEach(menu => {
      htmlTerm += `<a ref="nofollow" data-i18n="${menu.label}" class="nav-category${(typeof menu.isHide === "function" && menu.isHide()) || menu.hide ? " hide" : ""}" href="${menu.href}"></a>`
    })
    $(".menu-footer.menu-term .col-menu", this.element).html(htmlTerm).i18n();

  }

  reload() {
    this.fillData(this.listOffices, LocalStorage.getLanguage());
  }

  getLocation(language) {
    apiGetLocationOffice(
      (data) => {
        this.listOffices = data?.data;
        this.fillData(data?.data, language);
      },
      () => {
        $(".col-right", this.element).addClass("hide");
      }
    )
  }

  fillData(data, language) {
    if (!data) {
      $(".col-right", this.element).addClass("hide");
      return;
    }
    $(".col-right", this.element).removeClass("hide");
    let office = language && data[language] ? data[language] : data["default"];
    if (office) {
      $(".col-right", this.element).html("");
      office.forEach((element) => {
        new LocationItem({
          parent: $(".col-right", this.element),
          location: element,
          hidePrefix: true,
          isCompact: true
        })
      });
      $(".col-right", this.element).removeClass("hide");
    } else {
      $(".col-right", this.element).addClass("hide");
    }
  }

  onLanguage(newLang) {
    this.showRegisted(newLang === "vi");
    this.showBlogs(newLang);
    this.fillData(this.listOffices, newLang)
  }

  onChangeCountry(newShip) {
    if (isCountryVN(newShip)) {
      $(".menu-footer .col-menu .nav-category[country=VN]", this.element).removeClass("hide");
    } else {
      $(".menu-footer .col-menu .nav-category[country=VN]", this.element).addClass("hide");
    }
  }

  showRegisted(isShow) {
    isShow ? $(".registed", this.element).removeClass("hide") : $(".registed", this.element).addClass("hide");
  }

  showBlogs(language = "") {
    $(`.menu-footer .col-menu .nav-category[lang]`, this.element).addClass("hide");
    $(`.menu-footer .col-menu .nav-category[lang=${language}]`, this.element).removeClass("hide");
  }
}
